export default "__VITE_ASSET__Df$8J89x__"